import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { media } from "../../styles/breakpoints";

const Title = styled.p`
  text-align: center;
  word-wrap: break-word;
  color: ${(props) => (props.color ? props.color : "#676767")};
  font-size: 15px;

  ${media.sm`
    font-size: 20px;
  `}

  ${media.md`
    font-size: 22px;
  `}

  ${media.lg`
    font-size: 30px;
  `}
`;

const propTypes = {
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string,
};

function Text({ text, textColor }) {
  return <Title color={textColor}>{text}</Title>;
}

Text.propTypes = propTypes;

export default Text;
